import React from 'react';
import classes from './PageLoading.module.scss';

const PageLoading = () => {
    return (
        <div className={classes.loading}>
            <span>G</span>
            <span>O</span>
            <span>O</span>
            <span>D</span>
            <span> </span>
            <span>P</span>
            <span>A</span>
            <span>R</span>
            <span>T</span>
            <span>N</span>
            <span>E</span>
            <span>R</span>
        </div>
    );
};

export default PageLoading;
